export default "__VITE_ASSET__CQvC7pib__"